import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";

export const Container = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { tabs } = tokens;

    return css`
      background: ${tabs.mobile.backgroundColor};
      padding-top: ${tabs.mobile.padding.top};
      padding-left: ${tabs.mobile.padding.left};
      padding-right: ${tabs.mobile.padding.right};
      padding-bottom: ${tabs.mobile.padding.bottom};
      border-top-left-radius: ${tabs.mobile.radius.topLeft};
      border-top-right-radius: ${tabs.mobile.radius.topLeft};
      border-top-width: ${tabs.mobile.strokeTop.width};
      border-top-style: ${tabs.mobile.strokeTop.style};
      border-top-color: ${tabs.mobile.strokeTop.color};
    `;
  }}
`;
